export const BRAND = "Fafali";
export const BRAND_SUB = "Property Group";
export const TAGLINE = "Chain free property service made easy";

export const AREAS = [
  "Westminster & Central", "Kensington & Chelsea", "Camden & Islington", "Hackney & Tower Hamlets",
  "Southwark & Lambeth", "Wandsworth & Battersea", "Hammersmith & Fulham", "Richmond & Kingston",
  "Greenwich & Lewisham", "Barnet & Enfield", "Croydon & Bromley", "Ealing & Hounslow",
  "Other Greater London", "Elsewhere in the UK",
];

export const CHAIN_STATUSES = [
  "No chain - first-time buyer",
  "No chain - cash buyer",
  "No chain - my property is already sold & completed",
  "Property sold subject to contract (STC)",
  "Property on the market, not yet sold",
  "Not selling - keeping my current property",
];

export const OWNERSHIP_STATUSES = [
  "Not a homeowner (renting / living with family)",
  "Homeowner - selling my current property",
  "Homeowner - keeping my current property",
  "Investor / limited company",
];

export const PROOF_TYPES = [
  "Mortgage Agreement in Principle (AIP)",
  "Proof of funds - bank statement",
  "Proof of funds - solicitor / accountant letter",
  "AIP + proof of deposit",
];

export const BUYER_TIMELINES = ["Ready to proceed now", "Within 1 month", "Within 1-3 months"];
export const PROPERTY_TYPES = ["Flat / Apartment", "Maisonette", "Terraced house", "Semi-detached house", "Detached house", "Bungalow", "Other"];
export const BEDROOMS = ["Studio", "1", "2", "3", "4", "5+"];
export const TENURES = ["Freehold", "Leasehold", "Share of Freehold"];
export const SELL_TIMELINES = ["As fast as possible (under 4 weeks)", "Within 1-2 months", "Within 3 months"];
export const SELL_REASONS = ["Relocation", "Downsizing / upsizing", "Probate / inheritance", "Financial", "Investment sale", "Other"];

export const STATUS_OPTIONS = {
  buyers: ["pending_review", "verified", "matched", "viewing", "offer_made", "completed", "rejected"],
  sellers: ["new", "contacted", "valuation", "listed", "under_offer", "completed", "withdrawn"],
  enquiries: ["new", "contacted", "viewing", "closed"],
};

export const STATUS_LABELS = {
  pending_review: "Pending review", verified: "Funds verified", matched: "Matched", viewing: "Viewing",
  offer_made: "Offer made", completed: "Completed", rejected: "Not approved", new: "New", contacted: "Contacted",
  valuation: "Valuation", listed: "Listed", under_offer: "Under offer", withdrawn: "Withdrawn", closed: "Closed",
  available: "Available", sold: "Sold",
};
